module.exports = __webpack_public_path__ + "static/img/partners.9f39cb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/partners.png
// module id = nk+5
// module chunks = 0